/**
 * SportSkill class - Simplified version for VideoPlaylist feature
 * 
 * Only includes properties actually used:
 * - id: Skill identifier (used for mapping and display)
 * - name: Skill name (used for display)
 */
export class SportSkill {
  _id;
  _name;
  _order;

  static fromGraphQL(data) {
    return new SportSkill({
      id: data.id,
      name: data.name,
      order: data.order,
    });
  }

  constructor({ id, name, order }) {
    this._id = id ? Number(id) : undefined;
    this._name = name;
    this._order = order;
  }

  get id() {
    return this._id || undefined;
  }

  get name() {
    return this._name || undefined;
  }

  get order() {
    return this._order || undefined;
  }
}
